import { LayoutContext } from '@lib/site-context'
import cx from 'classnames'
import { Fragment, useContext, useEffect, useRef } from 'react'
import { useResizeObserver } from 'usehooks-ts'
import SimpleLink from './simple-link'

export interface Breadcrumb {
  url?: string
  title?: string
}

interface BreadcrumbsProps {
  items: Breadcrumb[]
  className?: string
}

const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
  const { headerHeight, setBreadcrumbsHeight } = useContext(LayoutContext)

  const breadcrumbsRef = useRef<HTMLDivElement | null>(null)

  const breadcrumbsRectangle = useResizeObserver({
    ref: breadcrumbsRef,
  })

  useEffect(() => {
    setBreadcrumbsHeight(breadcrumbsRectangle.height ?? 0)
  }, [breadcrumbsRectangle, setBreadcrumbsHeight])

  return (
    <section
      ref={breadcrumbsRef}
      className="sticky z-10 bg-pageBG bg-opacity-95"
      style={{
        top: headerHeight,
      }}
    >
      <div
        className={cx(
          'container flex flex-wrap items-center gap-1 py-3 border-b border-gray text-xs leading-tight',
          className,
        )}
      >
        {items.map((item, index) => (
          <Fragment key={`breadcrumbs-${index}-${item.title}`}>
            {!!item.url && (
              <SimpleLink href={item.url} className="hover:underline">
                {item.title}
              </SimpleLink>
            )}
            {!item.url && <span className="opacity-30">{item.title}</span>}

            {index < items.length - 1 && (
              <span className="bg-current w-[0.25rem] h-[1px]" />
            )}
          </Fragment>
        ))}
      </div>
    </section>
  )
}

export default Breadcrumbs
